import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Button, Col, Drawer, Input, List, Modal, Popover, Row, Select, Skeleton, message, Tag } from 'antd'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHookstate } from '@hookstate/core'
import { AdditionalInfoGlobalState } from '../../../../refactory/modules/jobs/infrastructure/job-detail/additional-info-global-state'

import PotentialPayment from '@commonComponents/PotentialPayment'
import ResourceCard from '@commonComponents/ResourceCard'
import ResourceProfile from '@domain/resource-profile'
import { getStores } from '../../../resource-management/resource-management.services'
import { assignTask, reAssignTask } from '../../flag-management.services'
import { reAssignTaskByResourceIdRepository } from '../../../../refactory/modules/jobs/infrastructure/odin-nebula-re-assign-task-by-resourceId.repository'
import { updateTaskByResourceUseCase } from '../../../../refactory/modules/jobs/application/update-task-by-resource-use-case'
import { getResoucesCanTakeTaskUseCase } from '../../../../refactory/modules/jobs/application/get-resouces-can-take-task.use-case'

const { Option } = Select
let query = {}
const { Search } = Input

const Assign = (props) => {
  const { t } = useTranslation()
  const { deliveryResourceAssigned } = useHookstate(AdditionalInfoGlobalState)
  const [searchBy, setSearchBy] = useState('name')
  const [showConfirm, setShowConfirm] = useState({})
  const [stores, setStores] = useState([])
  const [selectedStore, setSelectedStore] = useState([])
  const [queryStores] = useState({
    limit: 200,
    offset: 0,
    latitude: 0,
    longitude: 0,
    radius: 100000
  })
  const [filters, setFilters] = useState({
    quotaless: true
  })
  const [loading, setLoading] = useState(true)
  const [resources, setResources] = useState([])
  const [btnLoading, setBtnLoading] = useState(false)
  const [showResourceProfile, setShowResourceProfile] = useState(false)
  const [selectedResourceId, setSelectedResourceId] = useState()
  const reAssignTaskByResourceDataUseCaseInteractor = updateTaskByResourceUseCase(reAssignTaskByResourceIdRepository)
  const getResoucesCantTakeTaskUseCaseInteractor = getResoucesCanTakeTaskUseCase(reAssignTaskByResourceIdRepository)

  const filter = (value) => {
    onChangeFilters({ ...filters, [searchBy]: value })
  }

  const assignOrReAssignResource = async (resource, isReAssign, task, jobId) => {
    if (!resource.shouldReceivePush && isReAssign) {
      const result = await reAssignTaskByResourceDataUseCaseInteractor({
        taskId: task.uuid,
        resourceId: resource.id
      })
      if (result) {
        message.success(t('jobs.tasks.re-assign.success'))
      } else {
        message.error(t('jobs.tasks.re-assign.error'))
      }
      handleShowConfirm(resource.id)
      props.onClose()
    } else if (resource.shouldReceivePush && isReAssign) {
      const result = await reAssignTask(jobId, task.uuid, resource)

      if (result && result.invitation.state === 'SENT') {
        message.success(t('jobs.tasks.re-assign.success'))
        if (task.steps[task.steps.length - 1].type.name === 'DELIVERING') {
          deliveryResourceAssigned.set(resource)
        }
      } else {
        message.error(t('jobs.tasks.re-assign.error'))
      }

      handleShowConfirm(resource.id)
      props.onClose()
    } else {
      const updatedJob = await assignTask(jobId, task.uuid, resource)

      if (updatedJob) {
        if (props.jobsSearch) props.setSelectedJob(updatedJob)
        props.onClose()
        message.success(t('jobs.tasks.assign.success'))
        if (task.steps[task.steps.length - 1].type.name === 'DELIVERING') {
          deliveryResourceAssigned.set(resource)
        }
        handleShowConfirm(resource.id)
      }
    }
  }

  const assignResourceByTask = async (resource) => {
    if (props.handlerConfirmAssign) {
      props.handlerConfirmAssign(resource)
    } else {
      setBtnLoading(true)
      try {
        const { isReAssign, task, jobId } = props
        await assignOrReAssignResource(resource, isReAssign, task, jobId)
      } catch (error) {
        console.error(error)
        message.error(t('error-assign-resource'))
        throw new Error(error)
      } finally {
        setBtnLoading(false)
      }
    }
  }

  const handleShowConfirm = (id) => {
    setShowConfirm({
      ...showConfirm,
      ...{
        [id]: showConfirm[id] ? !showConfirm[id] : true
      }
    })
  }

  const getAssignOptions = (resource) => {
    return (
      <div className='confirm-options'>
        <Button onClick={() => handleShowConfirm(resource.id)} size='small'>
          <u>{t('jobs.job.info.items-view.no')}</u>
        </Button>
        <Button
          id={props.isReAssign ? 're-assign-resource' : 'assign-resource'}
          loading={btnLoading}
          onClick={() => assignResourceByTask(resource)}
          type='primary'
          size='small'
        >
          <u>{t('jobs.job.info.items-view.yes')}</u>
        </Button>
      </div>
    )
  }

  const changeRolPickerDriver = {
    PICKING: 'Pickers',
    DELIVERY: 'Drivers'
  }

  const getResources = async (task, query) => {
    setLoading(true)
    let newResourceList = []

    const resourceList = await getResoucesCantTakeTaskUseCaseInteractor(task.uuid, query.quotaless, {
      pagination: {
        limit: 200,
        offset: 0
      },
      query
    })

    const groupedResources = resourceList.resources.reduce((result, currentValue) => {
      ;(result[currentValue['id']] = result[currentValue['id']] || []).push(currentValue)
      return result
    }, {})

    Object.keys(groupedResources).forEach((key) => {
      const duplicatedResources = groupedResources[key]
      const resourceWithQuota = duplicatedResources.find((resource) => resource.withQuota)
      const resourceWithTakeQuotasEnabled = duplicatedResources.find((resource) => resource.isTakeQuotasEnabled)

      if (resourceWithQuota) {
        newResourceList.push(resourceWithQuota)
      } else if (resourceWithTakeQuotasEnabled) {
        newResourceList.push(resourceWithTakeQuotasEnabled)
      }
    })

    setResources(newResourceList)
    setLoading(false)
  }

  const onChangeFilters = useCallback(
    (selectedFilters) => {
      if (selectedFilters && selectedFilters.storeId) {
        query = { ...filters, ...selectedFilters }
        Object.keys(query).forEach((key) => {
          if (query[key] && query[key].length === 0) delete query[key]
        })
        setFilters(query)
        getResources(props.task, query)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.task]
  )

  const listStoresByResource = useCallback(() => {
    const { longitude, latitude } = props.store
    getStores({ ...queryStores, latitude, longitude }).then((result) => {
      if (result) {
        const { stores: storesResult } = result
        const initStore = storesResult.find((store) => store.id === props.store.id)
        if (initStore) {
          setStores(storesResult)
        } else {
          setStores([...storesResult, { id: props.store.id, location: props.store }])
        }
        if (props.store) {
          const { id } = props.store
          setSelectedStore(id)
          onChangeFilters({ storeId: id })
        }
      }
    })
  }, [onChangeFilters, props.store, queryStores])

  const onSearch = async (storeName) => {
    if (storeName.length > 3) {
      const { longitude, latitude } = props.store
      const result = await getStores({ ...queryStores, latitude, longitude, name: storeName })
      if (result) {
        const { stores: storesResult } = result
        setStores(storesResult)
      }
    }
    if (storeName.length === 0) {
      listStoresByResource()
    }
  }

  const onClear = () => {
    listStoresByResource()
  }

  const onChangeSelectedFilters = (value) => {
    setSearchBy(value)
    setFilters({ storeId: selectedStore })
  }

  const handleSelectStore = (storeId) => {
    setSelectedStore(storeId)
    onChangeFilters({ storeId })
  }

  const ResourceProfileParams = {
    ...props,
    resourceId: selectedResourceId,
    visible: showResourceProfile,
    onChangeVisible: setShowResourceProfile,
    clientTimeZone: props.tz
  }

  useEffect(() => {
    if (props.task && props.visible) {
      listStoresByResource()
    }
    return () => {
      setResources([])
    }
  }, [props.task, props.visible])

  return (
    <Drawer
      title={`${t('jobs.tasks.assign.title1')} ${
        props.task && props.task.name ? t(`jobs.tasks.name.${props.task.name}`) : ''
      }
      ${t('jobs.tasks.assign.title2')}`}
      placement='right'
      width={500}
      push={{ distance: 600 }}
      onClose={props.onClose}
      visible={props.visible}
    >
      <div className='assign-resource-search'>
        <label>
          {t('jobs.tasks.assign.label-search', {
            user: props.task && props.task.name ? changeRolPickerDriver[props.task.name] : ''
          })}
          :
        </label>
        <div className='filter-store'>
          <Select
            allowClear
            showSearch
            id='search-resources-to-assign-by-store'
            style={{ width: '100%' }}
            placeholder='Select a store'
            onChange={handleSelectStore}
            value={selectedStore}
            onSearch={onSearch}
            filterOption={false}
            onClear={onClear}
            disabled={props.allowChangeStore !== undefined && props.allowChangeStore === false}
          >
            {stores.map(({ id, location: { name } }, idx) => (
              <Option key={idx} value={id}>
                {name}
              </Option>
            ))}
          </Select>
        </div>
        <Search
          addonAfter={
            <Select
              style={{ width: 130, margin: 0 }}
              onChange={(value) => onChangeSelectedFilters(value)}
              defaultValue={searchBy}
            >
              <Option value='name'>{t('jobs.tasks.assign.select.name')}</Option>
              <Option value='phone'>{t('jobs.tasks.assign.select.phone-number')}</Option>
              <Option value='vehicleLabel'>{t('jobs.tasks.assign.select.vehicle-type')}</Option>
            </Select>
          }
          placeholder={t('jobs.tasks.assign.search-placeholder')}
          onSearch={(value) => filter(value)}
        />
      </div>
      <br />
      <Skeleton active loading={loading} paragraph={{ rows: 2 }} avatar={{ shape: 'square', size: 100 }}>
        <List
          className='assign-list'
          itemLayout='horizontal'
          dataSource={resources}
          renderItem={(resource) => {
            const {
              id,
              payment,
              photoUrl,
              name,
              vehicleType,
              distance,
              lastUpdatePosition,
              numberOfOrders,
              phoneNumber,
              withQuota,
              isTakeQuotasEnabled,
              shouldReceivePush,
              wantsToReceiveTasks
            } = resource
            return (
              <List.Item>
                <ResourceCard
                  copy={t}
                  showTagWithoutAssignedQuota={true}
                  potentialPayment={
                    payment ? (
                      <PotentialPayment payment={payment} potentialPaymentClass='assign-list-potential-payment' />
                    ) : null
                  }
                  timeZone={props.tz}
                  resource={{
                    id,
                    photoUrl: photoUrl,
                    firstName: name,
                    lastName: '',
                    vehicle: { label: vehicleType },
                    assignedTasks: numberOfOrders,
                    phone: phoneNumber,
                    lastUpdatePosition,
                    distance,
                    isTakeQuotasEnabled,
                    withQuota,
                    shouldReceivePush,
                    wantsToReceiveTasks
                  }}
                  actions={
                    <>
                      {withQuota ? (
                        <Popover
                          id='popover-confirm'
                          content={getAssignOptions(resource)}
                          title={t('jobs.job.info.items-view.confirm')}
                          trigger='click'
                          visible={showConfirm[resource.id]}
                          onVisibleChange={() => handleShowConfirm(resource.id)}
                        ></Popover>
                      ) : (
                        <Modal
                          visible={showConfirm[resource.id]}
                          onOk={() => assignResourceByTask(resource)}
                          okText={t('jobs.tasks.assign.assign')}
                          onCancel={() => handleShowConfirm(resource.id)}
                          cancelText={t('jobs.tasks.cancel')}
                          okButtonProps={{ loading: btnLoading }}
                        >
                          <Row>
                            <Col span={2}>
                              <ExclamationCircleOutlined style={{ color: '#FAAD14', fontSize: '20px' }} />
                            </Col>

                            <Col span={20}>
                              <h3> {t('jobs.tasks.manually-assign')} </h3>
                              <p> {t('jobs.tasks.confirmation-to-assign-resources-without-quota')} </p>
                              <strong>{t('jobs.tasks.continue')}</strong>
                            </Col>
                          </Row>
                        </Modal>
                      )}

                      <div align='right' className='assign-actions'>
                        {props.onSelectDriverForAdditionalInfo ? (
                          <Button onClick={() => props.onSelectDriverForAdditionalInfo(resource)}>{t('select')}</Button>
                        ) : resource.id === props.task?.resources?.resourceId ? (
                          <Tag className='assigned-tag' color={'default'}>
                            {t('flags.assigned')}
                          </Tag>
                        ) : (
                          <Button onClick={() => handleShowConfirm(resource.id)}>
                            {withQuota && shouldReceivePush
                              ? t('jobs.tasks.re-assign.invite')
                              : t('jobs.tasks.assign.assign')}
                          </Button>
                        )}
                      </div>
                    </>
                  }
                  onClickResource={(resourceId) => {
                    setSelectedResourceId(resourceId)
                    setShowResourceProfile(true)
                  }}
                />
              </List.Item>
            )
          }}
        />
      </Skeleton>
      <ResourceProfile {...ResourceProfileParams} />
    </Drawer>
  )
}

export default Assign
